import React, { useEffect, useState } from "react";
import styles from './AnotherRentalsInputs.module.scss'
import cn from 'classnames';
import { Lang } from "../../../types/common-types";
import { actions, Dispatch, State } from "../../../state-actions-reducers";
import AnotherRentalsItem from "../AnotherRentalItem/AnotherRentalItem";
import AddButton from "../../Buttons/AddButton";
import RadioInput from "../RadioInput/RadioInput";

interface AnotherRentalsInputsProps {
    lang: Lang
    state: State
    dispatch: Dispatch
    accountForm: any
    invalidFields: string[]
}
export default function AnotherRentalsInputs({ lang, state, dispatch, accountForm, invalidFields }: AnotherRentalsInputsProps) {
    const [rentalsCount, setRentalsCount] = useState(1)
    console.log('invalidfields', invalidFields)
    const rentals = () => {
        let list = []
        for (let i = 0; i < rentalsCount; i++) {
            list.push(
                <AnotherRentalsItem
                    key={`rental-${i}`}
                    lang={lang}
                    state={state}
                    invalidFields={invalidFields}
                    dispatch={dispatch}
                    index={i}
                    disabled={false}
                    deleteHandler={() => {
                        (state.rentals?.[i]?.rentalName) ?
                            dispatch({
                                type: actions.RENTALS,
                                data: state.rentals.filter((e, index) => {
                                    return i !== index
                                })
                            }) :
                            setRentalsCount(rentalsCount - 1)
                    }}
                />
            )
        }
        return list
    }
    const [rentalsList, setRentalsList] = useState(rentals)
    const [initialization, setInitialization] = useState(false)
    useEffect(() => {
        setRentalsList(rentals)
    }, [
        rentalsCount,
        invalidFields,
        state.rentals
    ])
    useEffect(() => {
        (!initialization && state.rentals.length > 0) && setRentalsCount(state.rentals.length)
        setInitialization(true)
    }, [state.rentals])
    useEffect(() => {
        if (!state.rentalsCheck) dispatch({ type: actions.RENTALS, data: [] })
    }, [state.rentalsCheck])
    console.log('state.rentals', state.rentals)
    return <div className="form-group">
        <div className="row">
            <div className={cn("col-12 col-xs-12", styles.rentalsTitle)}>
                <h3>{accountForm.stepTwoRentalsTitle[lang]}</h3>
            </div>
            <div className="col-4 col-xs-12">
                <div className={styles.rentalsCheckBox}>
                    <RadioInput name={'isAnotherRentalsYes'} lang={lang} label={accountForm.isAnotherRentalsYes} value={state.rentalsCheck} onChange={(e) => dispatch({
                        type: actions.RENTALS_CHECK,
                        data: !state.rentalsCheck,
                    })} />
                    <RadioInput name={'isAnotherRentalsNo'} lang={lang} label={accountForm.isAnotherRentalsNo} value={!state.rentalsCheck} onChange={(e) => dispatch({
                        type: actions.RENTALS_CHECK,
                        data: !state.rentalsCheck,
                    })} />
                </div>
            </div>
        </div>
        {state.rentalsCheck && <>
            {rentalsList}
            <div className="row">
                <div className="col-12 col-xs-12">
                    {state.rentals.length < 6 && (
                        <div
                            className={styles.addButtonBox}
                            onClick={() => {
                                setRentalsCount(rentalsCount + 1);
                                dispatch({
                                    type: actions.RENTALS,
                                    data: [
                                        ...state.rentals,
                                        {
                                            rentalName: "",
                                            rentalDiscount: "",
                                            rentalDataFile: {},
                                        },
                                    ],
                                });
                            }}
                        >
                            <AddButton />
                            <span>{accountForm.rentalsButton[lang]}</span>
                        </div>
                    )}
                </div>
            </div>
        </>}
    </div>
}